import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import { formatNumberWithDelimiter } from "../../../modules/number_formatting_utils";

export default GrComponentFactory.createClass({
  displayName: "GroupJoinDetails",

  propTypes: {
    title: React.PropTypes.string.isRequired,
    url: React.PropTypes.string.isRequired,
    memberCount: React.PropTypes.number.isRequired,
    joinUrl: React.PropTypes.string.isRequired,
    isMember: React.PropTypes.bool.isRequired,
  },

  renderJoinGroupButton() {
    if (!this.props.isMember) {
      return <a href={this.props.joinUrl}
                className="gr-button u-marginTopMedium">
               Join Group
             </a>;
    }
  },

  getGroupTitleHTML() {
    return { __html: this.props.title };
  },

  renderMemberText() {
    return `${formatNumberWithDelimiter(this.props.memberCount)} ${this.props.memberCount === 1 ? "Member" : "Members"}`;
  },

  render() {
    return (
      <div className="gr-newsfeedItem__details">
        <a href={this.props.url} className="gr-newsfeedItem__resourceNameLink" dangerouslySetInnerHTML={this.getGroupTitleHTML()}/>
        <div className="gr-newsfeedItem__groupDetailsText u-defaultType">
          {this.renderMemberText()}
        </div>
        {this.renderJoinGroupButton()}
      </div>
    );
  },
});
